/* スクロールで画面に入ったらフェードイン*/
function initFadeIn(selector) {
  var blockEl = document.getElementById(selector);
  if (!blockEl) {
    return;
  }
  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) {
            blockEl.classList.add('is-visible');
            observer.disconnect();
        }
    });
}, { threshold: 0.2 });
  observer.observe(blockEl);
}